import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LinkIcon from '@mui/icons-material/Link';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SendIcon from '@mui/icons-material/Send';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Paper,
  Divider,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT, UI_TIME_ZONE } from 'src/constants/formats';
import { archLevel } from 'src/data/config';
import { useLazyGetEtmfDocDetailsByTmfDocumentIdQuery } from 'src/services/etmfDocLevel';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { EmailActivity } from '../EmailActivity';
import { useIssueLog } from '../IssueLog/useIssueLog';
import { useMonitoringVisitLog } from '../MonitoringVisitLogs/useMonitoringVisitLog';
import { useProtocolQALog } from '../ProtocolQ&ALog/useProtocolQA';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import '../StudyLogs.scss';
import { useSIVFollowupLetter } from './useSIVFollowupLetter';
import { MainRTE } from '@pihealth/common-ui-library';
import StaticJson from '../../../../resources/static.json';
import Loader from 'src/components/common/Loader';

interface SIVFprops {
  siteStudyPersonnelsData: any;
  sivVisitData: any;
  setSIVFollowupLetterOpen: (isSivOpen: boolean) => void;
  setOpenLetter: (isStudyLogOpen: boolean) => void;
  setStudyLogOpen: any;
}

const SIVFollowupLetter: React.FunctionComponent<any> = (props: SIVFprops) => {
  const { siteStudyPersonnelsData, sivVisitData, setOpenLetter, setStudyLogOpen } = props;
  const { selectedAppSection } = useSelectedAppInfo();
  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const { getPreferredDateInLocal, userPreferedDateFormat, preferedFormatForDatePicker } = usePreferedDateFormat();
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const { checkPermission } = usePermissionWrapper();
  const updateSIVFLPermission = checkPermission('update_si_followupletter');
  const publishSIVFLpermission = checkPermission('publish_siv_followupletter');
  const editSIVFLPermission = checkPermission('edit_siv_followup_letter');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const dispatch = useAppDispatch();
  const { user: userFullName } = useUser();

  const initialData = {
    visit_follow_up: {
      visit_scheduled_date: '',
      siv_cra_first_name: userFullName,
      siv_salutation_letter: '',
      siv_follow_up_sponsor_name: sponsor?.toUpperCase(),
      siv_follow_up_publish_version: 0,
      tp_document_meta_id: '',
      tp_document_id: '',
      monitoring_visit_id: sivVisitData[0]?.id,
      id: '',
      siv_visit_issue: 'Site Initialtion Visit',
      siv_visit_start_date: '',
      siv_visit_end_date: '',
      siv_visit_qa: 'Site Initialtion Visit',
      siv_visit_start_date_qa: '',
      siv_visit_end_date_qa: ''
    },
    protocol_qa: [],
    issues: []
  };
  const [isChanged, setIsChanged] = useState(false);
  const [salulationErr, setSalulationErr] = useState(false);
  const [sivFLdetails, setSIVFLdetails] = useState(initialData);
  const [sivFLdetailsError, setSIVFLdetailsError] = useState<any>({
    siv_visit_start_date_qa: null,
    siv_visit_start_date: null,
    siv_visit_end_date_qa: null,
    siv_visit_end_date: null
  });
  const [openImport, setOpenImport] = useState(false);
  const [logType, setLogType] = useState('');
  const [filteredIssues, setFilteredIssues] = useState([]);
  const [filteredProtocolQA, setFilteredProtocolQA] = useState([]);
  const [openEmailPopoup, setOpenEmailPopoup] = useState(false);
  const [openRTE, setOpenRTE] = useState(false);
  const [openRTEContent, setOpenRTEContent] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');
  const [disableBtn, setDisableBtn] = useState(false);
  const [disableEditContent, setDisableEditContent] = useState(false);
  const [openVersionPopup, setOpenVersionPopup] = useState(false);

  const {
    selectSivFollowupLetter,
    selectSivFollowupLetterData,
    selectSivFollowupLetterIsLoading,
    updateSivFollowupLetter,
    updateSivFollowupLetterIsLoading,
    updateSivFollowupLetterIsError,
    updateSivFollowupLetterError,
    updateSivFollowupLetterIsSuccess,
    publishSivFollowupLetter,
    publishSivFollowupLetterIsLoading,
    publishSivFollowupLetterIsError,
    publishSivFollowupLetterError,
    publishSivFollowupLetterIsSuccess,
    createNewVersion,
    createNewVersionIsLoading,
    createNewVersionIsSuccess
  } = useSIVFollowupLetter();
  const { getAllMonitoringVisits } = useMonitoringVisitLog();
  const { unSavedWarning } = useFieldTranslation();
  const [getDocumentOnTmfDocumentId, { data: documentOnTmfDocumentIdData }] =
    useLazyGetEtmfDocDetailsByTmfDocumentIdQuery();
  const isUpdatePublish = selectSivFollowupLetterData?.visit_follow_up?.siv_follow_up_publish_version ? true : false;

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: currentApp,
      data: {}
    });
    if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
      const sivCheckedInDate: any = allMonitoringResponse.data.selected_data.filter(
        (visit: any) => visit.visit_type === 'Site Initiation Visit'
      );
      if (sivCheckedInDate.length && sivCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${sivCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };
  const { getIssueLogBasedOnDateRange } = useIssueLog();
  const { getProtocolQALogBasedOnDateRange } = useProtocolQALog();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);

  const getAllSIVFLdata = async () => {
    await selectSivFollowupLetter({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      visit_follow_up_id: sivVisitData[0]?.id
    });
  };

  const handleSalutation = (e: any) => {
    setSIVFLdetails({
      ...sivFLdetails,
      visit_follow_up: { ...sivFLdetails?.visit_follow_up, [e.target.name]: e.target.value }
    });
    setSalulationErr(false);
    setIsChanged(true);
    setConfirmExitValue(dispatch, true);
  };

  const validationOfRTE =
    selectSivFollowupLetterData?.visit_follow_up?.siv_rte1 === '' ||
    selectSivFollowupLetterData?.visit_follow_up?.siv_rte1 === null
      ? StaticJson.SIVFollowupLetterRTE
      : selectSivFollowupLetterData?.visit_follow_up?.siv_rte1;

  const handleSaveSIVFL = async () => {
    if (sivFLdetails?.visit_follow_up?.siv_salutation_letter) {
      const payload = {
        visit_follow_up: {
          visit_scheduled_date: checkedInStartDate
            ? moment.utc(checkedInStartDate).format()
            : sivVisitData[0]?.start_date_save,
          siv_cra_first_name:
            sivFLdetails?.visit_follow_up?.siv_cra_first_name ||
            sivFLdetails?.visit_follow_up?.siv_cra_first_name != null
              ? sivFLdetails?.visit_follow_up?.siv_cra_first_name
              : userFullName,
          siv_salutation_letter: sivFLdetails?.visit_follow_up?.siv_salutation_letter,
          siv_follow_up_sponsor_name: sponsor?.toUpperCase(),
          siv_follow_up_publish_version: sivFLdetails?.visit_follow_up?.siv_follow_up_publish_version,
          tp_document_meta_id: sivFLdetails?.visit_follow_up?.tp_document_meta_id,
          tp_document_id: sivFLdetails?.visit_follow_up?.tp_document_id,
          monitoring_visit_id: sivFLdetails?.visit_follow_up?.monitoring_visit_id,
          id: sivFLdetails?.visit_follow_up?.id,
          siv_visit_issue: sivFLdetails?.visit_follow_up?.siv_visit_issue,
          siv_visit_start_date: sivFLdetails?.visit_follow_up?.siv_visit_start_date,
          siv_visit_end_date: sivFLdetails?.visit_follow_up?.siv_visit_end_date,
          siv_visit_qa: sivFLdetails?.visit_follow_up?.siv_visit_qa,
          siv_visit_start_date_qa: sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa,
          siv_visit_end_date_qa: sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa,
          is_published: false,
          siv_isf_publish_version: 0,
          siv_rte1: htmlContent === '' ? validationOfRTE : htmlContent
        },
        protocol_qa: sivFLdetails?.protocol_qa,
        issues: sivFLdetails?.issues,
        updated_by: userFullName
      };
      updateSivFollowupLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        data: payload
      });
      setConfirmExitValue(dispatch, false);
      setDisableBtn(false);
    } else {
      setSalulationErr(true);
      setConfirmExitValue(dispatch, true);
    }
  };
  // To open Send Modal
  const [openSend, setOpenSend] = React.useState(false);

  const handleClose = () => {
    setOpenSend(false);
  };

  const handleChange = (_: SelectChangeEvent) => {
    // setVisit(event.target.value);
  };

  const handleClickOpenImport = (log: string) => {
    setOpenImport(true);
    setLogType(log);
    setSIVFLdetails({
      ...sivFLdetails,
      visit_follow_up: {
        ...sivFLdetails?.visit_follow_up,
        siv_visit_issue: sivVisitData[0]?.visit_name,
        siv_visit_qa: sivVisitData[0]?.visit_name
      }
    });
    setConfirmExitValue(dispatch, true);
  };

  const handleCloseImport = () => {
    setOpenImport(false);
    setSIVFLdetailsError({
      siv_visit_start_date_qa: null,
      siv_visit_start_date: null,
      siv_visit_end_date_qa: null,
      siv_visit_end_date: null
    });
  };

  const handleImportSumbit = async () => {
    setIsChanged(true);
    if (logType === 'issues') {
      if (
        sivFLdetails?.visit_follow_up?.siv_visit_start_date !== 'Invalid Date' &&
        sivFLdetails?.visit_follow_up?.siv_visit_end_date !== 'Invalid Date' &&
        ((!!sivFLdetailsError?.siv_visit_start_date && !!sivFLdetailsError?.siv_visit_end_date) ||
          (sivFLdetails?.visit_follow_up?.siv_visit_start_date != null &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date != null))
      ) {
        const filteredIssues: any = await getIssueLogBasedOnDateRange({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          issue_level: 'SPONSOR',
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          start_date: sivFLdetails?.visit_follow_up?.siv_visit_start_date,
          end_date: sivFLdetails?.visit_follow_up?.siv_visit_end_date
        });
        if (
          filteredIssues?.isSuccess &&
          filteredIssues?.data?.selected_data &&
          filteredIssues?.data?.selected_data.length > 0
        ) {
          const modifiedIssues: any = filteredIssues?.data?.selected_data.map((ele: any) => {
            return {
              id: ele.issue_details?.id,
              stdy_siv_subject_id: ele.issue_details?.subject_id,
              stdy_siv_issue_class: ele.issue_details?.issue_class,
              stdy_siv_issues: ele.issue_details?.issue,
              stdy_siv_category: ele.issue_details?.category,
              stdy_siv_action_description: ele.issue_details?.action_des,
              stdy_siv_action_due_date: ele.issue_details?.action_due
            };
          });
          setSIVFLdetails({ ...sivFLdetails, issues: modifiedIssues });
          setFilteredIssues(modifiedIssues);
          setConfirmExitValue(dispatch, true);
        } else {
          setSIVFLdetails({ ...sivFLdetails, issues: [] });
          setFilteredIssues([]);
          dispatch(setMessage({ msgDetails: 'No Issues', severity: 'error' }));
        }
        setOpenImport(false);
      } else {
        let sivFLdetailsErrorModified = { ...sivFLdetailsError };
        if (
          sivFLdetails?.visit_follow_up?.siv_visit_start_date == null ||
          sivFLdetails?.visit_follow_up?.siv_visit_start_date === 'Invalid Date' ||
          ((sivFLdetailsError.siv_visit_start_date == false || sivFLdetailsError.siv_visit_start_date == null) &&
            sivFLdetails?.visit_follow_up?.siv_visit_start_date == null &&
            sivFLdetails?.visit_follow_up?.siv_visit_start_date == 'Invalid Date')
        ) {
          sivFLdetailsErrorModified = { ...sivFLdetailsErrorModified, siv_visit_start_date: true };
        }
        if (
          sivFLdetails?.visit_follow_up?.siv_visit_end_date == null ||
          sivFLdetails?.visit_follow_up?.siv_visit_end_date === 'Invalid Date' ||
          ((sivFLdetailsError.siv_visit_end_date == false || sivFLdetailsError.siv_visit_end_date == null) &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date == null &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date == 'Invalid Date')
        ) {
          sivFLdetailsErrorModified = { ...sivFLdetailsErrorModified, siv_visit_end_date: true };
        }

        setSIVFLdetailsError({ ...sivFLdetailsError, ...sivFLdetailsErrorModified });
        dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
      }
    } else {
      if (
        sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa !== 'Invalid Date' &&
        sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa !== 'Invalid Date' &&
        ((!!sivFLdetailsError?.siv_visit_start_date_qa && !!sivFLdetailsError?.siv_visit_end_date_qa) ||
          (sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa != null &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa != null))
      ) {
        const filteredProtocolQA: any = await getProtocolQALogBasedOnDateRange({
          protocol_qa_level: 'SPONSOR',
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          start_date: sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa,
          end_date: sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa
        });
        if (
          filteredProtocolQA?.isSuccess &&
          filteredProtocolQA?.data?.selected_data &&
          filteredProtocolQA?.data?.selected_data.length > 0
        ) {
          const modifiedProtocolQA: any = filteredProtocolQA?.data?.selected_data.map((ele: any) => {
            return {
              id: ele.protocol_qa_details?.id,
              stdy_siv_topic: ele.protocol_qa_details?.topic,
              stdy_siv_description: ele.protocol_qa_details?.description,
              stdy_siv_response: ele.protocol_qa_details?.response,
              stdy_siv_response_dt: ele.protocol_qa_details?.response_dt,
              stdy_siv_status: ele.protocol_qa_details?.status
            };
          });
          setSIVFLdetails({ ...sivFLdetails, protocol_qa: modifiedProtocolQA });
          setFilteredProtocolQA(modifiedProtocolQA);
          setConfirmExitValue(dispatch, true);
        } else {
          dispatch(setMessage({ msgDetails: 'No Protocol Q&A', severity: 'error' }));
          setSIVFLdetails({ ...sivFLdetails, protocol_qa: [] });
          setFilteredProtocolQA([]);
        }
        setOpenImport(false);
      } else {
        let sivFLdetailsErrorModified = { ...sivFLdetailsError };
        if (
          sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa == null ||
          sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa === 'Invalid Date' ||
          ((sivFLdetailsError?.siv_visit_start_date_qa == false ||
            sivFLdetailsError?.siv_visit_start_date_qa == null) &&
            sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa == null &&
            sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa == 'Invalid Date')
        ) {
          sivFLdetailsErrorModified = { ...sivFLdetailsErrorModified, siv_visit_start_date_qa: true };
        }
        if (
          sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa == null ||
          sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa === 'Invalid Date' ||
          ((sivFLdetailsError?.siv_visit_end_date_qa == false || sivFLdetailsError?.siv_visit_end_date_qa == null) &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa == null &&
            sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa == 'Invalid Date')
        ) {
          sivFLdetailsErrorModified = { ...sivFLdetailsErrorModified, siv_visit_end_date_qa: true };
        }
        setSIVFLdetailsError({ ...sivFLdetailsError, ...sivFLdetailsErrorModified });
        dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
      }
    }
  };

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };
  // Dialog modal ends
  const handleBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      setOpenLetter(true);
      setStudyLogOpen(false);
    }
  };

  const handlePublishSIVFL = () => {
    if (publishSIVFLpermission) {
      publishSivFollowupLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        monitoring_visit_id: sivFLdetails?.visit_follow_up?.monitoring_visit_id,
        time_zone_id: UI_TIME_ZONE,
        publish_doc_version:
          Number(sivFLdetails?.visit_follow_up?.siv_follow_up_publish_version) >= 1
            ? (Math.floor(sivFLdetails?.visit_follow_up?.siv_follow_up_publish_version) + 1).toFixed(1).toString()
            : '1.0',
        is_published: true,
        update: isUpdatePublish
      });
    }
    setDisableBtn(true);
  };

  const printSIVFL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: sivFLdetails?.visit_follow_up?.monitoring_visit_id,
        template_name: 'site_initiation_visit_follow-up_letter',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
        }
      };
      printPdfWithViewer('get_imvChecklist_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleEmailActivity = () => {
    setOpenEmailPopoup(true);
  };

  const getDocumentBasedTmfDocumentId = async (tpDocumentId: any) => {
    await getDocumentOnTmfDocumentId({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      tmfDocumentId: tpDocumentId,
      application: `${archLevel == 'sponsor' ? 'CTMS' : 'TSDA'}`,
      module_section_related: 'STUDY LOGS',
      parent_entity_related: sivVisitData[0]?.visit_name
    });
  };

  useEffect(() => {
    if (selectSivFollowupLetterData?.visit_follow_up?.tp_document_id) {
      getDocumentBasedTmfDocumentId(selectSivFollowupLetterData?.visit_follow_up?.tp_document_id);
    }
  }, [selectSivFollowupLetterData?.visit_follow_up]);

  useEffect(() => {
    if (selectSivFollowupLetterData) {
      setFilteredIssues(selectSivFollowupLetterData?.issues);
      setFilteredProtocolQA(selectSivFollowupLetterData?.protocol_qa);
      setSIVFLdetails(selectSivFollowupLetterData);
    }
  }, [selectSivFollowupLetterData]);

  useEffect(() => {
    if (createNewVersionIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'New site qualification follow-up letter version ready to modify.',
          severity: 'success'
        })
      );
      getAllSIVFLdata();
      setOpenVersionPopup(false);
      setIsChanged(false);
      setOpenRTEContent(false);
      setDisableEditContent(false);
    }
  }, [createNewVersionIsSuccess]);

  useEffect(() => {
    if (selectedSite === null) {
      handleBack();
    }
  }, [studyId, selectedCountry, selectedSite]);

  useEffect(() => {
    if (updateSivFollowupLetterIsLoading || selectSivFollowupLetterIsLoading || createNewVersionIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [updateSivFollowupLetterIsLoading, selectSivFollowupLetterIsLoading, createNewVersionIsLoading]);

  useEffect(() => {
    if (updateSivFollowupLetterIsError || publishSivFollowupLetterIsError) {
      const err: any = updateSivFollowupLetterError || publishSivFollowupLetterError;
      if (err?.status == 500 || err?.status == 'FETCH_ERROR') {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [updateSivFollowupLetterIsError, publishSivFollowupLetterIsError]);

  useEffect(() => {
    if (publishSivFollowupLetterIsSuccess && !publishSivFollowupLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Successfully published to eTMF',
          severity: 'success'
        })
      );
      getAllSIVFLdata();
      setIsChanged(false);
    }
  }, [publishSivFollowupLetterIsSuccess, publishSivFollowupLetterIsLoading]);

  useEffect(() => {
    if (updateSivFollowupLetterIsSuccess && !updateSivFollowupLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Data updated Successfully',
          severity: 'success'
        })
      );
      getAllSIVFLdata();
      setOpenRTEContent(false);
      setDisableEditContent(false);
      setIsChanged(false);
    }
  }, [updateSivFollowupLetterIsSuccess, updateSivFollowupLetterIsLoading]);

  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, selectedAppSection);
    getAllSIVFLdata();
  }, [studyId]);

  const handleChangeTextEditor = (htmlContext: any, planetext: any) => {
    setHtmlContent(htmlContext);
  };
  const handleEditRTE = (content: string) => {
    setOpenRTE(true);
    setOpenRTEContent(true);
  };
  const handleSaveRTE = (content: string) => {
    setOpenRTE(false);
    setDisableEditContent(true);
    setIsChanged(true);
  };

  const handleCreateNewVersion = () => {
    setOpenVersionPopup(true);
    setDisableBtn(true);
  };

  const handleNewversionSIVFL = () => {
    createNewVersion({
      site_id: selectedSite,
      study_id: studyId,
      sq_visit_id: sivFLdetails?.visit_follow_up?.monitoring_visit_id,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      application_section: selectedAppSection
    });
    setOpenRTE(false);
    setOpenRTEContent(true);
    setDisableEditContent(false);
    setOpenVersionPopup(false);
  };

  return (
    <>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button onClick={handleBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          SIV Follow Up Letter List
        </Button>
      </Box>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {sivVisitData[0]?.visit_name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' ? (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                sx={{ alignSelf: 'center' }}
                disabled={
                  (archLevel === 'sponsor' && !publishSIVFLpermission) ||
                  disableBtn ||
                  !selectSivFollowupLetterData?.visit_follow_up?.siv_salutation_letter
                    ? true
                    : selectSivFollowupLetterData?.visit_follow_up?.is_published ||
                      selectSivFollowupLetterData?.visit_follow_up?.is_published == null ||
                      (isChanged && !disableBtn)
                }
                onClick={handlePublishSIVFL}
              >
                PUBLISH TO eTMF
              </Button>
            ) : (
              <Button variant="contained" sx={{ alignSelf: 'center' }} style={{ textTransform: 'none' }} disabled>
                PUBLISH TO eISF
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                disabled={
                  checkPermission('create_new_version_siv_followup_letter') ||
                  selectSivFollowupLetterData?.visit_follow_up?.is_published !== true
                }
                onClick={handleCreateNewVersion}
              >
                Create new version
              </Button>
            )}
            {/* Commented based on Future implementation */}
            {/* <Button sx={{ alignSelf: 'center' }} disabled>
              Create new version
            </Button> */}

            <Button
              sx={{ alignSelf: 'center' }}
              onClick={() => handleSaveSIVFL()}
              disabled={
                !updateSIVFLPermission || !isChanged ? true : selectSivFollowupLetterData?.visit_follow_up?.is_published
              }
            >
              Save
            </Button>
            <IconButton
              aria-label="Print"
              color="primary"
              sx={{ alignSelf: 'center' }}
              onClick={() => printSIVFL()}
              disabled={!selectSivFollowupLetterData?.visit_follow_up?.is_published}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {archLevel === 'sponsor' && (
              <IconButton
                aria-label="Send"
                color="primary"
                sx={{ alignSelf: 'center' }}
                onClick={() => handleEmailActivity()}
                disabled={
                  !checkPermission('email_sponsor_site_initiation_followup_letter') ||
                  !selectSivFollowupLetterData?.visit_follow_up?.is_published
                }
              >
                <SendIcon />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage">
        <Typography gutterBottom color="text.secondary2">
          {getPreferredDateInLocal(checkedInStartDate ? checkedInStartDate : sivVisitData[0]?.start_date)} <br />
          {siteStudyPersonnelsData?.site?.pi_first_name} {siteStudyPersonnelsData?.site?.pi_last_name} <br />
          {siteStudyPersonnelsData?.site?.site_name} <br />
          {siteStudyPersonnelsData?.site?.site_street_address1}
          {siteStudyPersonnelsData?.site?.site_street_address2 !== null
            ? `, ${siteStudyPersonnelsData?.site?.site_street_address2}`
            : ''}{' '}
          <br />
          {siteStudyPersonnelsData?.site?.site_city}
          {siteStudyPersonnelsData?.site?.site_state !== null ? `, ${siteStudyPersonnelsData?.site?.site_state}` : ''}
          {siteStudyPersonnelsData?.site?.site_zip_code !== null
            ? `, ${siteStudyPersonnelsData?.site?.site_zip_code}`
            : ''}
        </Typography>

        <dl className="text-Bold dlStyle">
          <dt>RE:</dt>
          <dd>
            Protocol {siteStudyPersonnelsData?.study?.study_id}-{siteStudyPersonnelsData?.study?.study_title} <br />
            Site Initiation Visit Follow-up Letter {siteStudyPersonnelsData?.study?.study_id}
            <br />
            Site Number: {siteStudyPersonnelsData?.site?.site_id}
          </dd>
        </dl>

        <Typography sx={{ mb: 1, pt: 2 }}>
          Dear &nbsp;{' '}
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="standard-error-helper-text"
              label="Salutation"
              variant="standard"
              name="siv_salutation_letter"
              className="fieldRequired"
              inputProps={{ maxLength: 50 }}
              value={sivFLdetails?.visit_follow_up?.siv_salutation_letter || ''}
              onChange={e => handleSalutation(e)}
              error={salulationErr}
              disabled={!updateSIVFLPermission || selectSivFollowupLetterData?.visit_follow_up?.is_published}
              helperText={salulationErr && 'Required'}
              sx={{ mt: '-16px !important' }}
            />
          </span>
          &nbsp; {siteStudyPersonnelsData?.site?.pi_first_name} {siteStudyPersonnelsData?.site?.pi_last_name},
          <br />
        </Typography>
        <Typography gutterBottom>
          I would like to thank you and your study team or [name key staff if applicable] for your time during the
          recent Site Initiation Visit conducted on{' '}
          {getPreferredDateInLocal(checkedInStartDate ? checkedInStartDate : sivVisitData[0]?.start_date)} for the
          above-mentioned study.
        </Typography>
        {editSIVFLPermission && selectSivFollowupLetterData?.visit_follow_up?.is_published !== true ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent}
                  onClick={() => handleEditRTE('content')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) => handleChangeTextEditor(htmlContext, planetext)}
                  value={validationOfRTE}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE
            }}
          />
        )}

        <p style={{ marginBottom: 8 }}>Issues raised during the visit:</p>
        {filteredIssues?.length > 0 && (
          <TableContainer sx={{ my: 2 }}>
            <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Subject ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Category</b>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Issue Class</b>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Issue</b>
                  </TableCell>
                  <TableCell>
                    <b>Action Description</b>
                  </TableCell>
                  <TableCell>
                    <b>Action Due Date</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredIssues.length ? (
                  filteredIssues?.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.stdy_siv_subject_id}</TableCell>
                      <TableCell>{row.stdy_siv_category}</TableCell>
                      <TableCell>{row.stdy_siv_issue_class}</TableCell>
                      <TableCell>{row.stdy_siv_issues}</TableCell>
                      <TableCell>{row.stdy_siv_action_description}</TableCell>
                      <TableCell>
                        {row.stdy_siv_action_due_date !== null
                          ? moment(row.stdy_siv_action_due_date).format(userPreferedDateFormat.toUpperCase())
                          : null}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={1}>
                    <TableCell colSpan={6}>No issues found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Button
          variant="contained"
          onClick={() => handleClickOpenImport('issues')}
          disabled={!updateSIVFLPermission || selectSivFollowupLetterData?.visit_follow_up?.is_published}
        >
          Import
        </Button>
        <br />

        <p style={{ marginBottom: 8 }}>Pending responses to questions raised during the visit:</p>
        {filteredProtocolQA?.length > 0 && (
          <TableContainer sx={{ my: 2 }}>
            <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Topic</b>
                  </TableCell>
                  <TableCell>
                    <b>Descriptions</b>
                  </TableCell>
                  <TableCell>
                    <b>Response</b>
                  </TableCell>
                  <TableCell>
                    <b>Response Date</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProtocolQA.length ? (
                  filteredProtocolQA?.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.stdy_siv_topic}</TableCell>
                      <TableCell>{row.stdy_siv_description}</TableCell>
                      <TableCell>{row.stdy_siv_response}</TableCell>
                      <TableCell>
                        {row.stdy_siv_response_dt !== null
                          ? moment(row.stdy_siv_response_dt).format(userPreferedDateFormat.toUpperCase())
                          : null}
                      </TableCell>
                      <TableCell>{row.stdy_siv_status}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={1}>
                    <TableCell colSpan={6}>No Protocol Q&A found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Button
          variant="contained"
          sx={{ mb: 2.5 }}
          onClick={() => handleClickOpenImport('protocolQA')}
          disabled={!updateSIVFLPermission || selectSivFollowupLetterData?.visit_follow_up?.is_published}
        >
          Import
        </Button>

        <Typography gutterBottom>
          A project team member will then be in touch with you in due course regarding the final decision on whether
          your site has been selected to participate in the study or not.
        </Typography>
        <Typography gutterBottom>
          Should you have any questions, please do not hesitate to contact me using the details below.
        </Typography>

        <Typography gutterBottom>
          Yours sincerely, <br />
          {sivFLdetails?.visit_follow_up?.siv_cra_first_name ||
          sivFLdetails?.visit_follow_up?.siv_cra_first_name != null
            ? sivFLdetails?.visit_follow_up?.siv_cra_first_name
            : userFullName}{' '}
          <br />
          <span color="text.secondary">{sponsor?.toUpperCase()}</span>
        </Typography>
      </Box>

      <Dialog
        open={openSend}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Share'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <TextField id="name-email" label="Enter Name or Email" variant="standard" fullWidth sx={{ mb: 1.5 }} />

          <TextField
            id="send-message"
            label="Type your message here.."
            variant="standard"
            fullWidth
            multiline
            rows={4}
            maxRows={4}
            margin="normal"
          />
          <br />
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
            <Grid item xs>
              <Button
                size="small"
                startIcon={<LinkIcon />}
                sx={{ ml: 2 }}
                className="nouppercase-btn"
                onClick={() => navigator.clipboard.writeText('URL copied..')}
              >
                Copy Shareable Link
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={handleClose} className="grey-btn">
                Close
              </Button>
              <Button onClick={handleClose} autoFocus>
                Share
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <PopupComponent open={openImport} sx={{ '@media (max-width:1367px)': { marginTop: '-136px' } }}>
        <DialogTitle id="alert-dialog-title">{'Import'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <Grid container spacing={2} className="event-form">
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel
                  required
                  id="selectVisit"
                  sx={{
                    '&[data-shrink="false"]': { transform: 'translate(0, 16px) scale(1)' },
                    '&[data-shrink="true"]': { transform: 'translate(0, -9px) scale(0.75)' }
                  }}
                >
                  Visit
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={'Site Initialtion Visit'}
                  label="Visit"
                  defaultValue={'10'}
                  onChange={handleChange}
                >
                  <MenuItem value={'10'}>{sivVisitData[0]?.visit_name}</MenuItem>
                </Select>
              </FormControl>

              <Grid />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    inputFormat={dateFormat}
                    label="Start Date"
                    value={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_start_date)
                        : preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa)
                    }
                    maxDate={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_end_date)
                        : preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa)
                    }
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        logType === 'issues'
                          ? setSIVFLdetails({
                              ...sivFLdetails,
                              visit_follow_up: {
                                ...sivFLdetails?.visit_follow_up,
                                siv_visit_start_date: getServerDateOrInvalid(newValue)
                              }
                            })
                          : setSIVFLdetails({
                              ...sivFLdetails,
                              visit_follow_up: {
                                ...sivFLdetails?.visit_follow_up,
                                siv_visit_start_date_qa: getServerDateOrInvalid(newValue)
                              }
                            });
                        setSIVFLdetailsError({
                          ...sivFLdetailsError,
                          siv_visit_start_date: false,
                          siv_visit_start_date_qa: false
                        });
                      } else {
                        setSIVFLdetailsError({
                          ...sivFLdetailsError,
                          siv_visit_start_date: true,
                          siv_visit_start_date_qa: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        required
                        error={sivFLdetailsError?.siv_visit_start_date || sivFLdetailsError?.siv_visit_start_date_qa}
                        helperText={
                          sivFLdetailsError?.siv_visit_start_date || sivFLdetailsError?.siv_visit_start_date_qa
                            ? 'Required'
                            : ''
                        }
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    //disableFuture
                    inputFormat={dateFormat}
                    label="End Date"
                    value={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_end_date)
                        : preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_end_date_qa)
                    }
                    minDate={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_start_date)
                        : preferedFormatForDatePicker(sivFLdetails?.visit_follow_up?.siv_visit_start_date_qa)
                    }
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        logType === 'issues'
                          ? setSIVFLdetails({
                              ...sivFLdetails,
                              visit_follow_up: {
                                ...sivFLdetails?.visit_follow_up,
                                siv_visit_end_date: getServerDateOrInvalid(newValue)
                              }
                            })
                          : setSIVFLdetails({
                              ...sivFLdetails,
                              visit_follow_up: {
                                ...sivFLdetails?.visit_follow_up,
                                siv_visit_end_date_qa: getServerDateOrInvalid(newValue)
                              }
                            });
                        setSIVFLdetailsError({
                          ...sivFLdetailsError,
                          siv_visit_end_date: false,
                          siv_visit_end_date_qa: false
                        });
                      } else {
                        setSIVFLdetailsError({
                          ...sivFLdetailsError,
                          siv_visit_end_date: true,
                          siv_visit_end_date_qa: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        required
                        error={sivFLdetailsError.siv_visit_end_date || sivFLdetailsError.siv_visit_end_date_qa}
                        helperText={
                          sivFLdetailsError.siv_visit_end_date || sivFLdetailsError.siv_visit_end_date_qa
                            ? 'Required'
                            : ''
                        }
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImport} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleImportSumbit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setOpenLetter(true);
              setStudyLogOpen(false);
              setIsChanged(false);
              setOpenConfirmExit(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      {openEmailPopoup && (
        <EmailActivity
          openEmailPopoup={openEmailPopoup}
          setOpenEmailPopoup={setOpenEmailPopoup}
          documentDetails={documentOnTmfDocumentIdData}
          permission={'UPDATE_SITEINITIATION_FOLLOWUPLETTER'}
        />
      )}
      <PopupComponent aria-labelledby="customized-dialog-title" open={openVersionPopup} maxWidth="lg">
        <DialogTitle>Please Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure you want to create a new version?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={() => setOpenVersionPopup(!openVersionPopup)}>
            Cancel
          </Button>
          <Button onClick={handleNewversionSIVFL}>Create</Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};

export default SIVFollowupLetter;
